import {computed, inject} from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { signalStore, withComputed, withMethods, withProps } from '@ngrx/signals';
import {ServiceApi} from "../../../../../core/data/service/service.api";

export const ServiceStore = signalStore(
  withProps((store, serviceApi = inject(ServiceApi)) => {
    return {
      _services: rxResource({
        stream: () => serviceApi.getServices(),
      })
    };
  }),
  withComputed(({ _services }) => ({
    // Exposed Data Signals
    services: computed(() => _services.value() || []),
  })),
  withMethods((store) => ({
    reload: () => {
      if (store._services.error()) {
        store._services.reload();
      }
    },
  })),
);
